<template>
    <el-dialog destroy-on-close append-to-body v-model="visible" title="团购核销验券" @close="emit('close')" width="600px"
        class="z-[99]">
        <div :class="['w-full', 'h-[200px]', 'bg-no-repeat bg-contain', 'relative', 'items-center']" :style="{
            background: `url(${bg})`,
        }">
            <div class="flex justify-center items-center p-2">
                <div @click="() => {
                    activeName = i.code;
                    form.code = ''
                }" v-for="i in switchList" :key="i.code"
                    class="w-full text-center flex justify-center relative pb-2">
                    <div class="flex items-center after:content-[''] " :class="[i.code == activeName ?
                        'after:absolute after:bottom-0 after:right-0 after:h-[4px]  after:bg-[var(--el-color-primary)] after:w-[40%] after:translate-x-[-50%] after:left-[50%]'

                        : '']">
                        <img :src="i.img" alt="">
                        <span class="ml-2">{{ i.title }}</span>
                    </div>
                </div>
            </div>
            <div class="flex items-center p-4 pt-6 pb-6 gap-x-4">
                <img :src="scan" alt="" @click="handleCamera">
                <el-input size="large" v-model="form.code">

                </el-input>
                <el-button :disabled="!form.code" class="ml-10 w-40 pl-8 pr-8 pt-6 pb-6" @click="search">查询</el-button>
            </div>
        </div>

        <el-table :data="tableData" @select="onSelect" @select-all="onSelect">
            <el-table-column type="selection" width="55" />
            <el-table-column property="itemName" label="项目名称" width="120" />
            <el-table-column property="itemNumber" label="核销数量" />
            <el-table-column property="itemPrice" label="核销金额" />
            <el-table-column property="services" label="服务人员" width="120">
                <template #default="scope">
                    <span @click="currentRow = scope.row"
                        v-show="scope.row.services && scope.row.services.length > 0">{{
                            scope.row.services.map((item:
                                any) => item.name).join(',') }}</span>
                    <el-popover trigger="click" :visible="Boolean(currentRow.id) && currentRow.id == scope.row.id"
                        placement="left-start" width="300">
                        <template #reference>
                            <div v-if="!scope.row.services || scope.row.services.length == 0"
                                @click="() => onClick(scope)" class="w-full flex items-center justify-end">
                                <CirclePlus class="w-[14px]" />
                                <div>
                                    添加技师
                                </div>
                            </div>
                        </template>
                        <template #default>
                            <Server @change="(server: any) => onServerChange(server, scope.row)"
                                :value="scope.row.services" :id="''">
                            </Server>
                        </template>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="showForm">
            <div class="p-2 text-[16px]">
                其他订单信息
            </div>
            <el-form :model="form" label-width="auto">
                <el-form-item label="顾客姓名">
                    <el-input v-model="form.userName" placeholder="请输入顾客姓名"> </el-input>
                </el-form-item>
                <el-form-item label="顾客手机号">
                    <el-input v-model="form.phoneNumber" placeholder="请输入顾客手机号" type="number"> </el-input>
                </el-form-item>
                <el-form-item label="房间号">
                    <el-select v-model="form.roomList" multiple placeholder="请选择房间号" style="width: 240px">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="同行人数">
                    <el-input-number v-model="form.personNumberMale" :min="0" :max="10" :step="1"></el-input-number>
                    <span class="mr-2 ml-2">男</span>
                    <el-input-number v-model="form.personNumberFemale" :min="0" :max="10" :step="1"></el-input-number>
                    <span class="mr-2 ml-2">
                        女
                    </span>
                </el-form-item>
                <el-form-item label="体验单">
                    <el-switch v-model="form.isExperience" class="mr-2" :active-value="1" :inactive-value="0" />
                    <el-date-picker format="YYYY-MM-DD" value-format="YYYY-MM-DD" :disabled="!form.isExperience"
                        v-model="form.experienceDate" type="date" placeholder="选择日期" />
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="submit">
                    确定
                </el-button>
            </div>
        </template>

        <Camera v-if="showCamera" ref="cameraRef" @stop="showCamera = false" @success="onSuccess"></Camera>
    </el-dialog>
</template>

<script lang="ts" setup>

import { reactive, ref, watch, onMounted, nextTick } from 'vue'
import meituan from '@/assets/image/settle/meituan.png'
import mini from '@/assets/image/settle/mini.png'
import bg from '@/assets/image/settle/bg.png'
import douyin from '@/assets/image/settle/douyin.png'
import scan from '@/assets/image/settle/scan.png'
import Server from './server.vue'
import { CirclePlus } from '@element-plus/icons-vue'
import { checkPrepare, checkVerify, getRoomList } from '@/api/settle'
import Camera from '@/views/settle/components/camera.vue'
import { ElNotification } from 'element-plus'
import {dayjs} from 'element-plus'
const emit = defineEmits(['close'])
const props = defineProps<{
    visi: boolean
}>()
const switchList = [
    {
        title: '美团',
        img: meituan,
        code: 3
    },
    {
        title: '小程序核销',
        img: mini,
        code: 1
    },
    {
        title: '抖音',
        img: douyin,
        code: 4
    },
]
const showForm = ref<boolean>(false)
const visible = ref<boolean>(false)
const activeName = ref<number>(3)
const orderId = ref<number>(0)
const currentRow = ref<any>({})
const showCamera = ref<boolean>(false)
const cameraRef = ref<InstanceType<typeof Camera> | null>(null)
const options = ref<{
    label: string
    value: string
}[]>([])
const selection = ref<any>([])

const tableData = ref<{
    detailId: string
    itemName: string
    itemNumber: number
    itemPrice: number
    itemId: string
    services: {
        name: string
        id: string
    }[]
}[]>([
])
const form = reactive<{
    userName: string
    phoneNumber: string
    roomList: number[]
    personNumberMale: number
    personNumberFemale: number
    experienceDate: string
    isExperience: number
    code: string
}>({
    userName: '',
    phoneNumber: '',
    personNumberMale: 1,
    personNumberFemale: 0,
    roomList: [],
    experienceDate: '',
    isExperience: 0,
    code: ''
})

const onServerChange = (server: any, row: any) => {
    currentRow.value = {
        id: ''
    }
    row.services = (server)

}

const search = async () => {
    try {
        await checkPrepare({
            receiptCode: form.code,
            parseType: activeName.value,
            codeType: form.code.startsWith('https') ? 2 : 1
        }).then((res) => {
            tableData.value = res.data.detailList.map((i: any, index: number) => {
                return {
                    ...i,
                    services: [],
                    id: String(i.itemId) + '' + index
                }
            })
            orderId.value = res.data.orderId
            form.phoneNumber = res.data.phoneNumber
            form.userName = res.data.userName

        })
        showForm.value = true
    } catch (err) {
        showForm.value = false
    }
}

const submit = async () => {
    if (selection.value.length == 0) {
        return ElNotification.error('请选择核销项目')
    }
    const params = {
        receiptCode: form.code,
        parseType: activeName.value,
        codeType: form.code.startsWith('https') ? 2 : 1,
        ...form,
        orderId: orderId.value,
        detailList: selection.value.map((i: any) => {
            const item = {
                ...i,
                consultantList: i.services.map((j: any) => j.id)
            }
            delete item.services
            return item
        }),
    }
    try {
        await checkVerify(params)
        ElNotification.success('核销成功')
        visible.value = false
    } catch (err) {

    }
    // const res = 
}
const handleCamera = () => {
    showCamera.value = true
    nextTick(() => {
        cameraRef.value.startScanning()
    })
}

const onSuccess = async (str: string) => {
    form.code = str
    await search()
}

const onClick = (scope) => {

    currentRow.value = scope.row
}

const onSelect = (s, row: any) => {
    console.log(s);
    selection.value = s
}
onMounted(async () => {
    const res = await getRoomList()
    options.value = res.data.map((item: any) => {
        return {
            value: item.id,
            label: item.name
        }
    })
})

watch(() => form.isExperience, (newValue) => {
    if (!newValue) {
        form.experienceDate = ''
    } else {
        form.experienceDate = dayjs().format('YYYY-MM-DD HH:mm:ss')
    }
})

watch(() => props.visi, (val) => {
    visible.value = val
    showForm.value = false
    tableData.value = []
    orderId.value = 0
    form.userName = ''
    form.phoneNumber = ''
    form.personNumberMale = 1
    form.personNumberFemale = 0
    form.roomList = []
    form.experienceDate = ''
    form.isExperience = 0
    form.code = ''

})
</script>